<template>
    <div>
        <div v-show='show' class='layer-pop square'>
            <div class='view-content small-padding' style='width: auto; max-width: 90vw'>
                <button class='close' @click='onClosePop'>
                    <span class='blind'>Popup Close</span>
                </button>
                <div class='com-scroll-y'>
                    <p class='pop-tit'>계약서 발송</p>
                    <div style='display: flex'>
                        <div class='send-num-pop' style='width: 380px'>
                            <table class='com-table' style='margin-top: 15px;'>
                                <colgroup>
                                    <col style='width: 35%' />
                                    <col style='width: 65%' />
                                    <col />
                                </colgroup>
                                <tbody>
                                <tr>
                                    <th>발송인<span class='require'></span></th>
                                    <td>{{info.centerName}}</td>
                                </tr>
                                <tr>
                                    <th>수신인<span class='require'></span></th>
                                    <td>{{info.customerName}}</td>
                                </tr>
                                <tr v-show='info.templateType == "M"'>
                                    <th>이용권 선택<span class='require'>*</span></th>
                                    <td>
                                        <select-form
                                            :select-data='["선택", ...(ticketList.filter(it => (it.index != sendTicket2 && it.index != sendTicket3)).map(ticket => {return convertTicketTypeFormat(ticket.cp_ticket_type_cd) + ticket.ccp_prod_nm + " (" + ticket.cc_less_cnt + "회)"}))]'
                                            :select-value='[-1, ...(ticketList.filter(it => (it.index != sendTicket2 && it.index != sendTicket3)).map((ticket, ticketIndex) => {return ticket.index}))]'
                                            :selected-value='sendTicket'
                                            @update:set='handleSelectTicket'
                                        ></select-form>
                                        <div v-show='sendTicket > -1 || sendTicket2Temp > -1'>
                                            <div style='display: flex; margin-top: 10px'>
                                                <select-form
                                                    :select-data='["선택", ...(ticketList.filter(it => (it.index != sendTicket && it.index != sendTicket3)).map(ticket => {return convertTicketTypeFormat(ticket.cp_ticket_type_cd) + ticket.ccp_prod_nm + " (" + ticket.cc_less_cnt + "회)"}))]'
                                                    :select-value='[-1, ...(ticketList.filter(it => (it.index != sendTicket && it.index != sendTicket3)).map((ticket, ticketIndex) => {return ticket.index}))]'
                                                    :selected-value='sendTicket2Temp'
                                                    @update:set='handleSelectTicket2'
                                                ></select-form>
                                                <button class='com-btn white' style='height: 30px; padding-left: 15px; padding-right: 15px; min-width: 60px;' @click='onAddTicket2'>추가</button>
                                            </div>
                                        </div>
                                        <div v-show='sendTicket2 > -1 || sendTicket3Temp > -1'>
                                            <div style='display: flex; margin-top: 10px'>
                                                <select-form
                                                    :select-data='["선택", ...(ticketList.filter(it => (it.index != sendTicket && it.index != sendTicket2)).map(ticket => {return convertTicketTypeFormat(ticket.cp_ticket_type_cd) + ticket.ccp_prod_nm + " (" + ticket.cc_less_cnt + "회)"}))]'
                                                    :select-value='[-1, ...(ticketList.filter(it => (it.index != sendTicket && it.index != sendTicket2)).map((ticket, ticketIndex) => {return ticket.index}))]'
                                                    :selected-value='sendTicket3Temp'
                                                    @update:set='handleSelectTicket3'
                                                ></select-form>
                                                <button class='com-btn white' style='height: 30px; padding-left: 15px; padding-right: 15px; min-width: 60px;' @click='onAddTicket3'>추가</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>계약서 선택<span class='require'>*</span></th>
                                    <td>
                                        <select-form
                                            :select-data="['회원', '직원']"
                                            :select-value='["M", "P"]'
                                            :selected-value='info.templateType'
                                            :disabled='true'
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <select-form
                                            :select-data="templateTitleList"
                                            :select-value='templateValueList'
                                            :selected-value='templateOption'
                                            @update:set='val => templateOption = val'
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>계약일<span class='require'></span></th>
                                    <td style='text-align: right'>{{getNowDatetime()}}</td>
                                </tr>
                                <tr>
                                    <th>서명 마감기한<span class='require'></span></th>
                                    <td style='text-align: right'>{{getDeadLineDatetime()}}</td>
                                </tr>
                                </tbody>
                            </table>
                          <div style='display: flex; margin-top: 10px; align-items: center'>
                              <span style='color: rgba(246, 68, 68, 1)'>계약서 발송 시 건당 300원이 부과되며, 미서명 및 취소 시에도 환불이 불가하니 신중히 발송해주시기 바랍니다.</span>
                            </div>
                            <div style='display: flex; margin-top: 120px; align-items: center'>
                                <div style='margin-left: auto; margin-right: 10px'>보유 SMS 금액 <span
                                    style='color: dodgerblue'>{{ Intl.NumberFormat().format((remains && remains.point) ? remains.point : 0) }}</span> 원
                                </div>
                                <button class='com-btn white' @click='onCharge'>충전</button>
                            </div>
                            <table class='com-table' style='margin-top: 10px;'>
                                <colgroup>
                                    <col style='width: 50%' />
                                    <col style='width: 50%' />
                                    <col />
                                </colgroup>
                                <tbody>
                                <tr>
                                    <th>발송 건수/금액<span class='require'></span></th>
                                    <td style='text-align: right'>1건 / {{ contractSendPrice }}원
                                    </td>
                                </tr>
                                <tr>
                                    <th>발송 가능 건수<span class='require'></span></th>
                                    <td style='text-align: right'>{{availableSendCount}}건</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class='contract-container' style='margin-top: 15px'>
                            <div class='contract-content' style='position: relative; padding: 0'>
                                <div class='carousel-indicator top-position'>
                                    <div class='carousel-indicator-pagination'>{{(contractInfo == null ? 0 : 1) + "/1"}} 페이지</div>
                                    <select-form
                                        class='contract-send-percent'
                                        :select-data="['25%', '50%', '70%', '100%', '120%', '150%']"
                                        :select-value='[25, 50, 70, 100, 120, 150]'
                                        :selected-value='contractZoom'
                                        @update:set='val => contractZoom = val'
                                    ></select-form>
                                </div>
                                <el-carousel
                                    ref="carousel"
                                    trigger="click"
                                    :interval="1000"
                                    :arrow="'none'"
                                    :autoplay="autoPlay"
                                    :indicator-position="'none'"
                                    style="height: 100%;"
                                >
                                    <el-carousel-item
                                        style='padding: 30px'
                                    >
                                        <div class='contract-title-input' style='margin-bottom: 20px; background-color: transparent'
                                            :style='`font-size: ${16 * contractZoom / 100}px`'>
                                            {{contractInfo == null ? "" : contractInfo.e_contract_title}}
                                        </div>
                                        <div class='contract-info-title' :style='`font-size: ${16 * contractZoom / 100}px`'>수신인 정보</div>
                                        <div style='display: flex'>
                                            <div class='contract-info-sub-title title' :style='`font-size: ${14 * contractZoom / 100}px`'>이름</div>
                                            <div class='contract-info-sub-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{info.customerName}}</div>
                                        </div>
                                        <div style='display: flex'>
                                            <div class='contract-info-sub-title title' :style='`font-size: ${14 * contractZoom / 100}px`'>연락처</div>
                                            <div class='contract-info-sub-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{info.customerPhone | phoneNumberFilter}}</div>
                                        </div>
                                        <div class='contract-info-title' v-show='info.templateType == "M" && (sendTicket > -1 || sendTicket2 > -1)' :style='`font-size: ${16 * contractZoom / 100}px`'>이용권 정보</div>
                                        <div v-show='sendTicket > -1' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title'>{{sendTicket > -1 ? getTicketTitle(sendTicket) : ""}}</div>
                                                <div class='ticket-box-info'>
                                                    <div style='flex: 1'>
                                                        {{sendTicket > -1 ? getTicketPeriod(sendTicket) : ""}}
                                                    </div>
                                                    <div>
                                                        {{sendTicket > -1 ? getTicketPrice(sendTicket) : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                            <img alt='Photo' src='/img/icons/ic_close.png' class='ticket-remove' @click='onRemoveTicket'>
                                        </div>
                                        <div v-show='sendTicket2 > -1' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title'>{{sendTicket2 > -1 ? getTicketTitle(sendTicket2) : ""}}</div>
                                                <div class='ticket-box-info'>
                                                    <div style='flex: 1'>
                                                        {{sendTicket2 > -1 ? getTicketPeriod(sendTicket2) : ""}}
                                                    </div>
                                                    <div>
                                                        {{sendTicket2 > -1 ? getTicketPrice(sendTicket2) : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                            <img alt='Photo' src='/img/icons/ic_close.png' class='ticket-remove' @click='onRemoveTicket2'>
                                        </div>
                                        <div v-show='sendTicket3 > -1' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title'>{{sendTicket3 > -1 ? getTicketTitle(sendTicket3) : ""}}</div>
                                                <div class='ticket-box-info'>
                                                    <div style='flex: 1'>
                                                        {{sendTicket3 > -1 ? getTicketPeriod(sendTicket3) : ""}}
                                                    </div>
                                                    <div>
                                                        {{sendTicket3 > -1 ? getTicketPrice(sendTicket3) : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                            <img alt='Photo' src='/img/icons/ic_close.png' class='ticket-remove' @click='onRemoveTicket3'>
                                        </div>
<!--                                        <div class='contract-info-sub-title' v-show='info.templateType == "M" && sendTicket > -1' :style='`font-size: ${14 * contractZoom / 100}px`'>{{sendCount + "/" + sendPrice}}</div>-->
<!--                                        <div class='contract-info-sub-title' v-show='info.templateType == "M" && sendTicket > -1' :style='`font-size: ${14 * contractZoom / 100}px`'>{{availableCount}} 건</div>-->
                                        <div>
                                            <div class='contract-info-title' :style='`font-size: ${16 * contractZoom / 100}px`'>약관</div>
                                            <div style='padding: 10px 10px 0 10px' v-for='(it, i) in (contractInfo == null ? [] : contractInfo.templateInfo)'>
                                                <div v-if='it.type == 1'>
                                                    <div class='contract-info-sub-title' style='display: flex'>
                                                        <input style='flex: 1; border: none' v-model='it.title' :style='`font-size: ${14 * contractZoom / 100}px`'>
                                                    </div>
                                                    <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent' :style='`font-size: ${14 * contractZoom / 100}px`' v-model='it.content' @change='onChangeItemContent()'></textarea>
                                                </div>
                                                <div v-else style='display: flex'>
<!--                                                    <div class='com-check' style='margin-top: 12px'>-->
<!--                                                        <input-->
<!--                                                            :id='`agree-check-${i}`'-->
<!--                                                            name='check-c1'-->
<!--                                                            type='checkbox'-->
<!--                                                            disabled-->
<!--                                                        />-->
<!--                                                        <label :for='`agree-check-${i}`' class='agree-option' style='cursor: default'></label>-->
<!--                                                    </div>-->
                                                    <div style='flex: 1;'>
                                                        <div class='contract-info-sub-title' style='display: flex'>
                                                            <input style='flex: 1; border: none' v-model='it.title' :style='`font-size: ${14 * contractZoom / 100}px`' />
                                                        </div>
                                                        <textarea class='contract-info-sub-title area' :style='`font-size: ${14 * contractZoom / 100}px`' v-model='it.content' style='resize: none; background-color: transparent' @change='onChangeItemContent()'></textarea>
                                                        <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                                                            <div class='com-check'>
                                                                <input
                                                                    :id='`agree-check-${i}-${j}`'
                                                                    name='check-c1'
                                                                    type='checkbox'
                                                                    disabled
                                                                />
                                                                <label :for='`agree-check-${i}-${j}`' class='agree-option' style='cursor: default'><div v-show='it.requiredFlag' class='check-required'>*</div></label>
                                                            </div>
                                                            <input v-model='jt.title' class='agree-option-input' :style='`font-size: ${14 * contractZoom / 100}px`' />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style='display: flex'>
                                            <div class='contract-info-title' style='flex: 1;' :style='`font-size: ${16 * contractZoom / 100}px`'>{{new Date() | dateFormatFilter2}}</div>
                                            <div style='width: 280px; margin-top: 40px;'>
                                                <div style='display: flex; align-items: center'>
                                                    <div class='contract-info-person' :style='`font-size: ${14 * contractZoom / 100}px`'>수신인: {{info.customerName}}</div>
                                                    <div class='contract-info-signature no-image' :style='`font-size: ${14 * contractZoom / 100}px`'>(서명)</div>
                                                </div>
                                                <div style='display: flex; align-items: center; margin-top: 10px;'>
                                                    <div class='contract-info-person' :style='`font-size: ${14 * contractZoom / 100}px`'>발신인: {{info.centerName}}</div>
                                                    <div class='contract-info-signature no-image' v-show='senderSignImageRawData == ""' :style='`font-size: ${14 * contractZoom / 100}px`'>(서명)</div>
                                                    <img class='contract-info-signature' v-show='senderSignImageRawData != ""' :src='senderSignImageRawData' />
                                                </div>
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                    </div>
                    <div class='bottom-btn' style='margin-top: 30px; padding-bottom: 0'>
                        <button class='com-btn white' @click='onClosePop'>취소</button>
                        <button class='com-btn white' @click='onPersonallySign'>직접 서명</button>
                        <button class='com-btn' @click='onPaymentLinkSend'>계약서 발송</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="signaturePop" class="layer-pop square">
            <div class="view-content small-padding" style='width: auto'>
                <button class="close" @click="closeSignaturePopup">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style='font-size: 18px; margin-bottom: 15px;'>서명을 입력해주세요.</p>
                    <canvas class='signature-container' id='canvas_signature_pad' width='500' height='400'></canvas>
                    <div class="bottom-btn" style='margin-top: 30px; padding-bottom: 0'>
                        <button class="com-btn white" @click="onReInput">다시입력</button>
                        <button class="com-btn white" @click="onCancelSignature">취소</button>
                        <button class="com-btn" @click="onInputComplete">입력완료</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="smsChargePop" class="layer-pop square">
            <div class="view-content w600">
                <button class="close" @click="smsChargePop = false">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">SMS 금액 충전</p>
                    <div class="sms-charge-pop">
                        <div class="info-wrap">
                            최소 충전 금액은 10,000원입니다. (부가세 제외)
                            <br />
                            충전금을 ‘직접 입력’으로 선택하셨을 경우, 금액은 만 원 단위로 숫자만 입력 가능합니다.
                        </div>
                        <table class="com-table">
                            <tbody>
                            <tr>
                                <th>
                                    쎈터명
                                    <span class="require">*</span>
                                </th>
                                <td>
                                    <input type="text" :value="info.centerName" readonly />
                                </td>
                            </tr>
                            <tr>
                                <th>보유금액</th>
                                <td class="won-text">
                                    <input type="text" :value="formatNumber((remains && remains.point) ? remains.point : 0)" readonly />
                                </td>
                            </tr>
                            <!-- 충전 금액 선택 -->
                            <tr>
                                <th>
                                    충전 금액
                                    <span class="require">*</span>
                                </th>
                                <td>
                                    <select-form :select-data="chargeAmountOptions.data"
                                                 :select-value="chargeAmountOptions.value"
                                                 :selectedValue="selectedChargeAmount" @update:set="handleSelectedTextChange"
                                                 @update:selected="handleChargeAmountChange"></select-form>
                                </td>
                            </tr>

                            <tr v-if="selectedChargeAmount === '직접 입력'">
                                <th>
                                    충전 금액
                                    <span class="require">*</span>
                                </th>
                                <td class="won-text">
                                    <input v-model="customChargeAmount" type="text"
                                           placeholder="금액을 입력하세요(만원 단위)" />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="table-info">
                            <strong>결제 진행 금액</strong>
                            <span class="amount">{{ formatNumber(finalChargeAmount) }}</span>
                            원 (부가세 포함)
                        </div>
                        <div class="com-check">
                            <input id="agreeCheckbox" name="agree" type="checkbox" v-model="isAgreed" />
                            <label for="agreeCheckbox">위 내용을 확인하였으며, 결제 진행에 동의합니다..</label>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="smsChargePop = false">취소</button>
                            <button @click="nicepayStart()" class="com-btn blue">다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form name="payForm" method="post" :action="paymentActionUrl" class="nicePay">
            <table>
                <tr>
                    <th>PayMethod</th>
                    <td>
                        <input type="hidden" name="PayMethod" value="CARD, VBANK" />
                    </td>
                </tr>
                <tr>
                    <th>GoodsName</th>
                    <td><input type="hidden" name="GoodsName" value="SMS Recharge" /></td>
                </tr>
                <tr>
                    <th>Amt</th>
                    <td>
                        <input type="hidden" name="Amt" v-model="finalChargeAmount" />
                    </td>
                    <!-- <td><input type="text" name="Amt" v-model=sampleAmt /></td> -->
                </tr>
                <tr>
                    <th>MID</th>
                    <td>
                        <input type="hidden" name="MID" v-model="MID" />
                    </td>
                </tr>
                <tr>
                    <th>Moid</th>
                    <td>
                        <input type="hidden" name="Moid" v-model="Moid" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerName</th>
                    <td>
                        <input type="hidden" name="BuyerName" v-model="uName" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerEmail</th>
                    <td>
                        <input type="hidden" name="BuyerEmail" v-model="staffEmail" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerTel</th>
                    <td>
                        <input type="hidden" name="BuyerTel" value="" />
                    </td>
                </tr>
                <tr>
                    <th>ReturnURL [Mobile only]</th>
                    <td>
                        <input type="hidden" name="ReturnURL" value="" />
                    </td>
                </tr>
                <tr>
                    <th>Virtual Account Expiration Date(YYYYMMDD)</th>
                    <td>
                        <input type="hidden" name="VbankExpDate" :value="nextWeekDate" />
                    </td>
                </tr>

                <input type="hidden" name="NpLang" value="KO" />
                <!-- EN:English, CN:Chinese, KO:Korean -->
                <input type="hidden" name="GoodsCl" value="1" />
                <!-- products(1), contents(0)) -->
                <input type="hidden" name="TransType" value="0" />
                <!-- USE escrow false(0)/true(1) -->
                <input type="hidden" name="CharSet" value="utf-8" />
                <!-- Return CharSet -->
                <input type="hidden" name="ReqReserved" value="" />
                <!-- mall custom field -->
                <!-- <input type="hidden" name="ConnWithIframe" value="Y" /> -->
                <input type="hidden" name="ConnWithIframe" value="N" />
                <!-- DO NOT CHANGE -->
                <input type="hidden" name="EdiDate" ref="ediDateInput" :value="ediDate" />
                <!-- YYYYMMDDHHMISS -->
                <!-- <input type="hidden" name="SignData" v-model="signData" /> -->
                <input type="hidden" name="SignData" ref="signDataInput" />
                <!-- signData -->
                <input type='hidden' name="VbankExpDate" value="20240324" />
            </table>
            <a href="#" class="btn_blue" @click="nicepayStart();">REQUEST</a>
        </form>

        <personally-sign-dlg
            v-if="personallySignPop"
            :show='personallySignPop'
            :data='personallySignData'
            :close="handleClosePersonallySignPop"
            :complete="handleCompletePersonallySign"
        ></personally-sign-dlg>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';
import CryptoJS from 'crypto-js';
import SignaturePad from 'signature_pad'
import PersonallySignDlg from './PersonallySignDlg'
import { Utils } from '@/assets/js/utils';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';

export default {
    name: 'ContractSendDlg',
    components: {
        PersonallySignDlg
    },
    props: {
        info: Object,
        show: Boolean,
        data: Object,
        close: Function,
        charge: Function,
        paymentLinkSend: Function,
    },
    watch: {
        templateOption(val) {
            if (val == -1) {
                this.$router.push({ name: 'SettingElectronicTemplateDetail', query: { templateId: 0 } })
            } else if (val == 0) {
                this.contractInfo = null;
            } else {
                const list = this.templateList.filter(item => item.e_id == val);
                if (list && list.length > 0) {
                    this.contractInfo = list[0];

                    this.autoHeightTextArea()
                }
            }
        },
        sendTicket(val) {
            const selectedTicket = this.ticketList.filter(item => item.cp_center_prod_id == val)
            if (selectedTicket && selectedTicket.length > 0) {
                this.sendCount = selectedTicket[0].cc_total_prod_cnt;
                this.sendPrice = selectedTicket[0].cc_total_buy_price;
                const remain = selectedTicket[0].cc_total_org_price - selectedTicket[0].cc_total_buy_price;
                this.availableCount = Math.floor((remain < 0 ? 0 : remain) / this.contractSendPrice);
            }
        },
    },
    data() {
        return {
            centerId: 0,

            sendTicket: -1,
            sendTicket2: -1,
            sendTicket2Temp: -1,
            sendTicket3: -1,
            sendTicket3Temp: -1,
            templateOption: 0,
            contractInfo: null,
            templateList: [],
            templateTitleList: [],
            templateValueList: [],
            contractSendPrice: 300,
            availableSendCount: 0,
            contractZoom: 100,

            signaturePop: false,
            signaturePad: null,
            autoPlay: false,

            ticketList: [],

            smsChargePop: false,
            remains: {
                lms: 0,
                mms: 0,
                sms: 0,
                kakao: 0,
            },
            chargeAmountOptions: {
                data: ['10,000원 (최소결제금액)', '30,000원', '50,000원', '100,000원', '직접 입력'],
                value: ['10,000원 (최소결제금액)', '30,000원', '50,000원', '100,000원', '직접 입력'],
                selectedChargeAmount: '',
            },
            selectedChargeAmount: '', // 선택된 충전 금액
            customChargeAmount: '', // 사용자가 입력한 충전 금액
            isAgreed: false,
            taxRate: 0.1, // 부가세율
            Moid: '',
            MID: process.env.VUE_APP_NICE_PAY_MID,
            merchantKey: process.env.VUE_APP_NICE_PAY_KEY,
            nextWeekDate: this.getNextWeekDate(),
            ediDate: '',
            sendCount: 0,
            sendPrice: 0,
            availableCount: 0,
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            fileGroupId: 0,
            senderSignImageRawData: "",
            base64data: "",

            personallySignPop: false,
            personallySignData: null,

          sendProcess: false,
        };
    },
    mounted() {
        this.init();

    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const {getters} = this.$store;
            return getters['auth/staffId'];
        },
        finalChargeAmount() {
            let amount = 0;
            // '직접입력' 선택 시 사용자가 입력한 금액을 사용
            if (this.selectedChargeAmount === '직접 입력') {
                // 사용자 입력값이 문자열인지 확인하고, 문자열로 변환
                const inputAmount = String(this.customChargeAmount);
                amount = parseFloat(inputAmount.replace(/,/g, '')) || 0;
            } else {
                // 선택된 금액 옵션 사용
                const selectedAmount = String(this.selectedChargeAmount);
                amount = parseFloat(selectedAmount.replace(/,/g, '')) || 0;
            }
            const finalAmount = amount + amount * this.taxRate;
            return Math.round(finalAmount);
        },
        paymentActionUrl() {
            return process.env.VUE_APP_PAYMENT_API_URL + '/admin/api/payment/approvalRequest';
        },
        uName() {
            const { getters } = this.$store;
            return getters['auth/userName'];
        },
        staffEmail() {
            const { getters } = this.$store;
            return getters['auth/staffEmail'];
        },
    },
    methods: {
        handleCompleteMessage(event) {
          // 보안: origin 검증
          console.log("이벤트 핸들러")
          if (event.origin !== window.location.origin) return;

          // this.data = event.data;
          // this.senderFileGroupId = this.data.senderFileGroupId;
          // this.senderSignImageRawData = this.data.senderSignImageRawData;
          console.log('수신된 데이터 1111111 :', event.data);
          if (!this.sendProcess) {
            this.sendProcess = true
            this.handleCompletePersonallySign(event.data, event.data.uploadFiles)
          }
        },
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            this.setSignaturePad();
            this.getAvailableTicketList();
            this.fetchRemainInfo();
            this.fetchTemplates();

            this.getSignatureList();
        },

        async getSignatureList() {
            try {
                this.isLoading = true;

                const response = await api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature`);
                if (response && response.data) {
                    response.data.map(item => {
                        if (item.s_rep) {
                            this.fileGroupId = item.s_file_group_id;

                            convertImgToDataURLviaCanvas(item.f_file_url, (imgRawData) => {
                                this.base64data = imgRawData; // 이미지 미리보기
                                this.senderSignImageRawData = this.base64data
                            })
                          // this.senderSignImageRawData = item.f_file_url;
                        }
                    })
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        setSignaturePad() {
            const canvas = document.querySelector("#canvas_signature_pad");
            this.signaturePad = new SignaturePad(canvas);

            this.signaturePad.addEventListener("endStroke", () => {
                const file = Utils.getFileFromRawImageData(this.signaturePad.toDataURL());
                this.setUploadFile(file);
            }, { once: false });
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async setUploadFile(file) {
            let base64data = await this.readFileAsync(file);
            this.base64data = base64data; // 이미지 미리보기
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('빈 파일은 첨부할 수 없습니다.');
                return;
            }
            const fileInfo = {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
            };

            this.fileGroupId = 0;
            this.uploadFiles = [fileInfo];
        },

        getTicketTitle(index) {
            return ( this.convertTicketTypeFormat(this.ticketList[index].cp_ticket_type_cd) + this.ticketList[index].ccp_prod_nm + ((this.ticketList[index].cp_ticket_type_cd != "T" && this.ticketList[index].cp_ticket_type_cd != "S") ? (" (" + this.ticketList[index].cc_less_cnt + "회" + ")") : ""))
        },

        getTicketPeriod(index) {
            return ((this.$options.filters.timestampFilter(this.ticketList[index].cc_exp_start_dt)) + " ~ " + this.$options.filters.timestampFilter(this.ticketList[index].cc_exp_end_dt))
        },

        getTicketPrice(index) {
          let priceInfo = '';
          if (!this.ticketList[index].cc_ret_yn) {
            priceInfo = this.convertBillInfo(this.ticketList[index].cc_bill_info);
          }
          return priceInfo;
            // return (this.convertPayType(this.ticketList[index].ccb_pay_type_cd) + this.$options.filters.numberFormatFilter(this.ticketList[index].cc_prod_buy_price))
        },

        async getAvailableTicketList() {
             const response = await api.get(`/admin/api/center/${this.info.centerId}/lesson`, {
                params: {
                    productType: 'T',
                    centerCustomerId: this.info.customerId,
                    page: 1,
                    limit: 9999,
                    totalItems: '',
                    itemCount: '',
                    totalPages: '',
                    route: '',
                },
            });
            const ticketTempList = response.data.items;
            let index = 0;
            ticketTempList.map((t, i) => {
                // TODO review
                if (parseInt(t.ticket_used_count) === 0) {
                    t.index = index
                    this.ticketList.push(t);
                    index++;
                }
            })
        },

        async onAddTicket2() {
            this.sendTicket2 = this.sendTicket2Temp
        },

        async onAddTicket3() {
            this.sendTicket3 = this.sendTicket3Temp
        },

        onRemoveTicket() {
            this.sendTicket = -1;
        },

        onRemoveTicket2() {
            this.sendTicket2 = -1;
            this.sendTicket2Temp = -1;
        },

        onRemoveTicket3() {
            this.sendTicket3 = -1;
            this.sendTicket3Temp = -1;
        },

        async onCharge() {
            this.smsChargePop = true;

            const centerIdAsNumber = Number(this.cId);
            let responseData = null;
            try {
                const response = await paymentApi.post('/admin/api/payment/createOrder', {
                    centerId: centerIdAsNumber,
                });
                console.log('Payment ready response:', response.data);
                responseData = response.data;
            } catch (error) {
                console.error('Payment preparation request failed:', error);
            }
            this.Moid = responseData;
        },

        onClosePop() {
            this.close();
        },

        showSignaturePopup() {
            this.signaturePop = true
        },

        closeSignaturePopup() {
            this.signaturePop = false
        },

      // 직접서명 버튼 클릭시 처리
        onPersonallySign() {
            if (this.contractInfo == null) {
                alert("계약서를 선택해 주세요.");
                return;
            }
            if (this.remains.point == undefined || this.remains.point < this.contractSendPrice) {
                alert("발송 금액이 부족합니다. 다시 확인해주세요.");
                return;
            }

            this.personallySignData = {
                info: this.info,
                contractInfo: this.contractInfo,
                ticketInfo: this.getTicketInfo(),
                senderFileGroupId: this.fileGroupId,
                senderSignImageRawData: this.senderSignImageRawData
            }
            // this.personallySignPop = true;
          const popup = window.open(`/madmin/member/info/${this.centerId}/sign`, "_blank", "width=1200,height=800");
          const interval = setInterval(() => {
            if (popup.closed) {
              console.log("팝업이 닫혔습니다!");
              clearInterval(interval);
            }
          }, 1000);

          // 새 창 로드 후 postMessage
          const sendMessage = () => {
            if (popup) {
              popup.postMessage(this.personallySignData, window.location.origin);
            }
          };

          // 새 창에서 메시지 받기 (이벤트 리스너 설정)
          window.addEventListener('message', (event) => {
            console.log("메시지 받기 ===========================");
            console.log(event.data);
            if (event.data === 'ready') {
              sendMessage();
            } else {
              this.handleCompleteMessage(event);
            }
          });
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll("textarea");
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = "auto"
                    areas.item(i).style.height = areas.item(i).scrollHeight + "px"
                }
            }, 10)
        },

        getTicketInfo() {
            let ticketInfoArray = [];
            if (this.sendTicket > -1) {
                ticketInfoArray.push({
                    title: this.getTicketTitle(this.sendTicket),
                    period: this.getTicketPeriod(this.sendTicket),
                    price: this.getTicketPrice(this.sendTicket)
                })
            }
            if (this.sendTicket2 > -1) {
                ticketInfoArray.push({
                    title: this.getTicketTitle(this.sendTicket2),
                    period: this.getTicketPeriod(this.sendTicket2),
                    price: this.getTicketPrice(this.sendTicket2)
                })
            }
            if (this.sendTicket3 > -1) {
                ticketInfoArray.push({
                    title: this.getTicketTitle(this.sendTicket3),
                    period: this.getTicketPeriod(this.sendTicket3),
                    price: this.getTicketPrice(this.sendTicket3)
                })
            }

            return ticketInfoArray;
        },

        onCheckOption() {
          let flag = true;
          if (this.contractInfo) {
            this.contractInfo.templateInfo.map(it => {
              if (it.type === 2 && it.requiredFlag) {
                if (it.options) {
                  let checkCount = 0;
                  it.options.map(jt => {
                    if (jt.checked) checkCount ++;
                  })
                  if (checkCount === 0) {
                    flag = false;
                  }
                }
              }
            })
          }

          return flag;
        },

      // 계약서 발송 버튼 클릭시 이벤트
        async onPaymentLinkSend() {
            // if (this.info.templateType == "M" && this.sendTicket == -1) {
            //     alert("이용권을 선택해주세요.");
            //     return;
            // }
            if (this.contractInfo == null) {
                alert("계약서를 선택해주세요.");
                return;
            }
            if (this.remains.point === undefined || this.remains.point < this.contractSendPrice) {
                alert("발송 금액이 부족합니다. 다시 확인해주세요.");
                return;
            }
            // 직접서명인 경우만 체크
            // if (!this.onCheckOption()) {
            //     alert("동의 여부 체크 후 서명 해 주세요.")
            //     return;
            // }
            if (this.uploadFiles.length === 0 && this.fileGroupId === 0) {
                alert("서명이미지를 입력하세요.");
                return;
            }
            if (confirm('계약서 발송 시 건당 금액이 부과 됩니다. 계약서를 발송 하시겠습니까?')) {

                let info = [];
                this.contractInfo.templateInfo.map(item => {
                    if (item.type === 2 && item.options && item.options.length > 0) {
                      item.options.map(it => {
                        it.checked = false;
                      })
                    }
                    info.push({
                        ...item,
                        title: item.title,
                        content: item.content,
                        requiredFlag: item.requiredFlag,
                        options: item.options,
                    })
                })

                let centerContractIdList = [];
                let centerProdIdList = [];
                if (this.info.templateType == "M") {
                    if (this.sendTicket > -1) {
                        centerContractIdList.push(this.ticketList[this.sendTicket].cc_center_contract_id);
                        centerProdIdList.push(this.ticketList[this.sendTicket].cp_center_prod_id);
                    }
                    if (this.sendTicket2 > -1) {
                        centerContractIdList.push(this.ticketList[this.sendTicket2].cc_center_contract_id);
                        centerProdIdList.push(this.ticketList[this.sendTicket2].cp_center_prod_id);
                    }
                    if (this.sendTicket3 > -1) {
                        centerContractIdList.push(this.ticketList[this.sendTicket3].cc_center_contract_id);
                        centerProdIdList.push(this.ticketList[this.sendTicket3].cp_center_prod_id);
                    }
                }

                const { data } = await api.post(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send`, {
                    senderId: this.info.centerId,
                    recipientId: this.info.customerId,
                    recipientName: this.info.customerName,
                    recipientPhone: this.info.customerPhone,
                    centerContractId: centerContractIdList.toString(),
                    centerProdId: centerProdIdList.toString(),
                    ticketSendCount: this.sendCount,
                    ticketSendPrice: this.sendPrice,
                    ticketAvailableCount: this.availableCount,
                    contractMemberType: this.info.templateType,
                    contractTemplateId: this.contractInfo.e_id,
                    contractInfo: info,
                    deadlineAt: this.getDeadLineDatetime(),
                    uploadFiles: this.uploadFiles,
                    fileGroupId: this.fileGroupId,
                    ticketInfo: JSON.stringify(this.getTicketInfo())
                });

                if (data) {
                    alert("계약서가 발송되었습니다.")
                    this.paymentLinkSend()
                }
            }
        },

        onReInput() {
            this.signaturePad.clear();
            this.base64data = "";
            this.uploadFiles = [];
        },

        onCancelSignature() {
            this.signaturePad.clear();
            this.closeSignaturePopup();
        },

        onInputComplete() {
            this.signaturePad.clear();
            this.senderSignImageRawData = this.base64data
            this.closeSignaturePopup();
        },

        getNowDatetime() {
            return moment().format('YYYY-MM-DD');
        },

        getDeadLineDatetime() {
            let time1 = moment().format('YYYY-MM-DD HH:mm:ss');
            let add = moment(time1).add({ days: 1 });

            return add.format('YYYY-MM-DD HH:mm:ss');
        },

        //쉼표 찍기
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        async fetchRemainInfo() {
            try {
                const { data: pointData } = await paymentApi.get(`/admin/api/payment/point/${this.info.centerId}`);

                const { remains } = this;
                const points = pointData.point || 0; // 사용 가능한 포인트
                // const points = 215938;

                // 각 메시지 타입별 단가
                const smsPrice = 12;
                const lmsPrice = 35;
                const mmsPrice = 90;
                const kakaoPrice = 12;
                // 각 메시지 타입별 최대 보낼 수 있는 메시지 수 계산
                const maxSmsCount = Math.floor(points / smsPrice);
                const maxLmsCount = Math.floor(points / lmsPrice);
                const maxMmsCount = Math.floor(points / mmsPrice);
                const maxKakaoCount = Math.floor(points / kakaoPrice);

                // 계산된 값으로 remains 객체 업데이트
                this.remains.sms = maxSmsCount;
                this.remains.lms = maxLmsCount;
                this.remains.mms = maxMmsCount;
                this.remains.kakao = maxKakaoCount;
                this.remains.point = points; // 남은 포인트도 업데이트

                if (points > 0) {
                    this.availableSendCount = Math.floor(points / this.contractSendPrice)
                }
            } catch (e) { }
        },
        handleSelectedTextChange(selectedText) {
            // 선택된 텍스트 값을 처리하는 로직
            console.log('Selected text:', selectedText);
        },
        handleChargeAmountChange(selectedText) {
            this.selectedChargeAmount = selectedText;
            console.log('Selected amount:', this.selectedChargeAmount);
        },
        async nicepayStart() {
            if (!this.isAgreed) {
                alert('이용약관에 동의해주세요.');
                return;
            }
            if (this.finalChargeAmount <= 10000) {
                alert('10,000원 이상부터 결제가 가능합니다.');
                return;
            }
            this.generateSignData();
            document.payForm.target = 'payForm';

            // Source/frontend-main/src/views/madmin/message/Send.vue의 charge방식을 참고하였는데 거기에도 이 함수본체가 없음.
            goPay(document.payForm);
        },
        generateSignData() {
            const ediDate = moment().format('YYYYMMDDHHmmss');
            this.$refs.ediDateInput.value = ediDate;
            this.ediDate = ediDate + 1;
            const dataString = ediDate + this.MID + this.finalChargeAmount + this.merchantKey;
            const hash = CryptoJS.SHA256(dataString);
            const hexHash = CryptoJS.enc.Hex.stringify(hash);

            // signData 값 업데이트
            this.signData = hexHash;

            // ref를 사용하여 SignData 입력 필드의 value를 직접 업데이트
            if (this.$refs.signDataInput) {
                this.$refs.signDataInput.value = hexHash;
            }
        },
        getNextWeekDate() {
            const date = new Date();
            date.setDate(date.getDate() + 7); // 일주일을 더함

            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하므로 1을 더함
            const day = ('0' + date.getDate()).slice(-2);

            return `${year}${month}${day}`;
        },
        fetchTemplates() {
            Promise.all([
                this.getTemplates(),
            ]).then((response) => {
                if (response && response.length > 0) {
                    this.templateList = response[0].data;
                    if (this.templateList) {
                        this.templateTitleList.push('선택')
                        this.templateValueList.push(0);
                        this.templateList.map((item) => {
                            this.templateTitleList.push(item.e_contract_title);
                            this.templateValueList.push(item.e_id);
                        })
                        this.templateTitleList.push('추가')
                        this.templateValueList.push(-1);
                    }
                }
            })
        },
        getTemplates() {
            let params = {
                searchMethod: this.info.templateType,
            };

            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/search`, {
                params,
            });
        },

        onChangeItemContent() {
            this.autoHeightTextArea();
        },

        handleSelectTicket(val) {
            // if (this.sendTicket2 == val || this.sendTicket3 == val) {
            //     alert("전자계약서를 작성 할 이용권이 없습니다.")
            // } else {
                this.sendTicket = val;
            // }
        },

        handleSelectTicket2(val) {
            // if (this.sendTicket == val || this.sendTicket3 == val) {
            //     alert("전자계약서를 작성 할 이용권이 없습니다.")
            // } else {
                this.sendTicket2Temp = val;
            // }
        },

        handleSelectTicket3(val) {
            // if (this.sendTicket == val || this.sendTicket2 == val) {
            //     alert("전자계약서를 작성 할 이용권이 없습니다.")
            // } else {
                this.sendTicket3Temp = val;
            // }
        },

        handleClosePersonallySignPop() {
            this.personallySignPop = false
        },

        async handleCompletePersonallySign(signData, uploadFiles) {
            let info = [];
            signData.contractInfo.templateInfo.map(item => {
                info.push({
                    ...item,
                    title: item.title,
                    content: item.content,
                    requiredFlag: item.requiredFlag,
                    options: item.options,
                })
            })

            let centerContractIdList = [];
            let centerProdIdList = [];
            if (this.info.templateType === "M") {
              if (this.sendTicket > -1) {
                centerContractIdList.push(this.ticketList[this.sendTicket].cc_center_contract_id);
                centerProdIdList.push(this.ticketList[this.sendTicket].cp_center_prod_id);
              }
              if (this.sendTicket2 > -1) {
                centerContractIdList.push(this.ticketList[this.sendTicket2].cc_center_contract_id);
                centerProdIdList.push(this.ticketList[this.sendTicket2].cp_center_prod_id);
              }
              if (this.sendTicket3 > -1) {
                centerContractIdList.push(this.ticketList[this.sendTicket3].cc_center_contract_id);
                centerProdIdList.push(this.ticketList[this.sendTicket3].cp_center_prod_id);
              }
            }

            const { data } = await api.post(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send`, {
                senderId: this.info.centerId,
                recipientId: this.info.customerId,
                recipientName: this.info.customerName,
                recipientPhone: this.info.customerPhone,
                centerContractId: centerContractIdList.toString(),
                centerProdId: centerProdIdList.toString(),
                ticketSendCount: this.sendCount,
                ticketSendPrice: this.sendPrice,
                ticketAvailableCount: this.availableCount,
                contractMemberType: this.info.templateType,
                contractTemplateId: this.contractInfo.e_id,
                contractInfo: info,
                deadlineAt: this.getDeadLineDatetime(),
                uploadFiles: uploadFiles,
                fileGroupId: this.fileGroupId,
                ticketInfo: JSON.stringify(this.getTicketInfo())
            });

            if (data) {
                alert("계약서가 발송 되었습니다.")
                this.personallySignPop = false
                this.paymentLinkSend()
            }
        },
        convertTicketTypeFormat(type) {
          if (type === 'P') {
            return '[개인]';
          } else if (type === 'O') {
            return '[OT]';
          } else if (type === 'D') {
            return '[듀엣]';
          } else if (type === 'G') {
            return '[그룹]';
          } else if (type === 'C') {
            return '[쿠폰]';
          } else if (type === 'T') {
            return '[회원권]';
          } else if (type === 'S') {
            return '[운동복]';
          }
          return "";
        },

        // 결제수단_금액 가공
        convertBillInfo(billInfo) {
          // ex) C_1300000|L_240000 결제수단_금액 으로 들어오는 string 값을 가공
          let result = '';
          if (billInfo === undefined) {
            // undeifiend인 경우
            return '-';
          }
          if (billInfo !== null) {
            const temp1 = billInfo.split('|');
            temp1.forEach((bill) => {
              console.log(bill)
              const temp2 = bill.split('_');
              let payType = '';
              switch (temp2[0]) {
                case 'C':
                  payType = '[카드]';
                  break;
                case 'L':
                  payType = '[현금]';
                  break;
                case 'B':
                  payType = '[계좌이체]';
                  break;
                case 'M':
                  payType = '[마일리지]';
                  break;
                case 'E':
                  payType = '[기타]';
                  break;
                case 'T':
                  payType = '[핏페이]';
                  break;
                case 'U':
                  payType = '[핏페이]';
                  break;
                case 'K':
                  payType = '[키오스크]';
                  break;
                default:
                  payType = '[-]';
              }
              result += `${payType} ${this.getNumberFormat(parseInt(temp2[1]))}`; // ex) [카드] 240,000원 으로 만듦
            });
            return result;
          }
          return result;
        },

        // 금액에 , 넣기
        getNumberFormat(num) {
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },
};
</script>
